// @flow

import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import {
  GetHierarchyTree,
  GetMyHierarchyTree,
  GetMyHierarchyTreeNew,
} from "@modules/shared/constants/actions";

type HierarchyTreeRequest = $Exact<{
  clientId: string,
  showEmployees?: boolean,
}>;

export function* onGetHierarchyTree({
  payload,
}: Action<HierarchyTreeRequest>): Generator<*, void, Object> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/active`,
      {
        params: {
          includeEmployeePositions: !!payload.showEmployees,
        },
      },
    );

    yield put(actionCreators.GetHierarchyTreeSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetHierarchyTreeError(e.response));
  }
}

export function* onGetMyHierarchyTree({
  payload,
}: Action<HierarchyTreeRequest>): Generator<*, void, Object> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/active-access-scope`,
    );

    yield put(actionCreators.GetMyHierarchyTreeSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetMyHierarchyTreeError(e.response));
  }
}
export function* onGetMyHierarchyTreeNew({
  payload,
}: Action<HierarchyTreeRequest>): Generator<*, void, Object> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }
    const data = yield call(
      http.get,
      `/api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/active-access-scope-new`,
    );
    yield put(actionCreators.GetMyHierarchyTreeSuccess(data.data));
  } catch (e) {
    yield put(actionCreators.GetMyHierarchyTreeError(e.response));
  }
}

export function* SharedSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(GetHierarchyTree, onGetHierarchyTree),
    takeEvery(GetMyHierarchyTree, onGetMyHierarchyTree),
    takeEvery(GetMyHierarchyTreeNew, onGetMyHierarchyTreeNew),
  ]);
}

export default SharedSagas;
